import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, StringField, Int32Field, Float32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class WerkstattParameterBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new WerkstattParameterBox({
            uuid,
            graph,
            name: "WerkstattParameterBox",
            pointerRules: NoPointers,
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "WerkstattParameterBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({});
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitWerkstattParameterBox, this);
    }
    get tags() {
        return WerkstattParameterBox.Tags;
    }
    get owner() {
        return this.getField(1);
    }
    get label() {
        return this.getField(2);
    }
    get index() {
        return this.getField(3);
    }
    get value() {
        return this.getField(4);
    }
    get defaultValue() {
        return this.getField(5);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "owner",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.Parameter, true),
            2: StringField.create({
                parent: this,
                fieldKey: 2,
                fieldName: "label",
                deprecated: false,
                pointerRules: NoPointers,
            }, ""),
            3: Int32Field.create({
                parent: this,
                fieldKey: 3,
                fieldName: "index",
                deprecated: false,
                pointerRules: NoPointers,
            }, "index", ""),
            4: Float32Field.create({
                parent: this,
                fieldKey: 4,
                fieldName: "value",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, "any", ""),
            5: Float32Field.create({
                parent: this,
                fieldKey: 5,
                fieldName: "defaultValue",
                deprecated: false,
                pointerRules: NoPointers,
            }, "any", ""),
        };
    }
}
